import { ChangeDetectionStrategy, Component, OnInit, effect, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PowerComponent } from '@/pages/power/power.component';
import { POWER_SERVICE } from 'src/api/power.service.interface';
import { CloudPowerService } from '@/cloud/services/cloud-power.service';
import { DeviceContextService } from '../device-context.service';

/**
 * Cloud wrapper for the Power page: the PDUs reported by this processor, provided to the shared
 * PowerComponent through POWER_SERVICE. The header comes from the Device shell.
 */
@Component({
    selector: 'app-cloud-power',
    standalone: true,
    imports: [PowerComponent],
    template: `
        @if (ready()) {
            <app-power [showHeader]="false" />
        }
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 0;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CloudPowerService, { provide: POWER_SERVICE, useExisting: CloudPowerService }]
})
export class CloudPowerComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private deviceCtx = inject(DeviceContextService);
    private powerService = inject(CloudPowerService);

    ready = signal(false);

    constructor() {
        // Controls follow the processor's tunnel state.
        effect(() => {
            const connected = this.deviceCtx.device()?.tunnelConnected;
            if (connected !== undefined) this.powerService.setTunnelConnected(connected);
        });
    }

    ngOnInit(): void {
        const deviceId = this.route.snapshot.paramMap.get('deviceId') ?? this.route.parent?.snapshot.paramMap.get('deviceId') ?? this.deviceCtx.device()?.id ?? '';
        if (deviceId) {
            this.powerService.setScope({ kind: 'device', deviceId });
            this.ready.set(true);
        }
    }
}
